import request from '@/http/requests/prompt';

export default {
    fetch( { commit }, data ) {
        return new Promise(
            (
                resolve,
                reject
            ) => {
                request.fetch( data.prompt_id, data.key, data.page, data.itemsPerPage )
                .then(
                    response => {
                        const parsedData = response.data.data.getPrompts;

                        commit('SET_PROMPT_PAGINATED', parsedData);
                        resolve(response);
                    }
                )
                .catch( exception => reject(exception) );
            }
        );
    },
    create( { commit }, data ) {
        return new Promise(
            (
                resolve,
                reject
            ) => {
                request.create(
                    data.key,
                    data.name,
                    data.prompt_id,
                    ( data.department_id || null ),
                    ( data.price || null ),
                    ( data.discount_price || null )
                )
                .then(
                    response => {
                        const parsedData = response.data.data.createPrompt;

                        commit('ADD_PROMPT', parsedData);
                        resolve(parsedData);
                    }
                )
                .catch( exception => reject(exception) );
            }
        );
    },
    update( { commit }, data ) {
        return new Promise(
            (
                resolve,
                reject
            ) => {
                request.update(
                    data.id,
                    ( data.name || null ),
                    ( data.department_id || null ),
                    ( data.is_active === undefined ? null : data.is_active ),
                    ( data.price || null ),
                    ( data.discount_price || null ),
                    ( data.has_redirect_flow === undefined ? null : data.has_redirect_flow )
                )
                .then(
                    response => {
                        const parsedData = response.data.data.updatePrompt;

                        commit('UPDATE_PROMPT', parsedData);
                        resolve(parsedData);
                    }
                )
                .catch( exception => reject(exception) );
            }
        );
    },
    delete( { commit }, id ) {
        return new Promise(
            (
                resolve,
                reject
            ) => {
                request.delete( id )
                .then(
                    response => {
                        commit('DELETE_PROMPT', id);
                        resolve(response);
                    }
                )
                .catch( exception => reject(exception) );
            }
        );
    },
    fetchInfos( { commit }, data ) {
        return new Promise(
            (
                resolve,
                reject
            ) => {
                request.fetch( data.prompt_id, data.key, 1, 4 )
                .then(
                    response => {
                        const parsedData = response.data.data.getPrompts;

                        commit('SET_PROMPT_INFOS', parsedData);
                        resolve(response);
                    }
                )
                .catch( exception => reject(exception) );
            }
        );
    },
    createInfos( { commit }, data ) {
        return new Promise(
            (
                resolve,
                reject
            ) => {
                request.create(
                    data.key,
                    data.name,
                    data.prompt_id,
                    null,
                    null,
                    null
                )
                .then(
                    response => {
                        const parsedData = response.data.data.createPrompt;

                        commit('ADD_PROMPT_INFOS', parsedData);
                        resolve(parsedData);
                    }
                )
                .catch( exception => reject(exception) );
            }
        );
    },
    updateInfos( { commit }, data ) {
        return new Promise(
            (
                resolve,
                reject
            ) => {
                request.update(
                    data.id,
                    ( data.name || '' ),
                    null,
                    null,
                    null,
                    null
                )
                .then(
                    response => {
                        const parsedData = response.data.data.updatePrompt;

                        commit('UPDATE_PROMPT_INFOS', parsedData);
                        resolve(parsedData);
                    }
                )
                .catch( exception => reject(exception) );
            }
        );
    },
    countOptions() {
        return new Promise(
            (
                resolve,
                reject
            ) => {
                request.countOptions()
                .then(
                    response => resolve(response.data.data.countPrompts)
                )
                .catch( exception => reject(exception) );
            }
        );
    }
}